import { useState, useEffect, useRef, useContext } from "react";
import "../style/SignUpOTPScreen.module.scss";
import "react-phone-input-2/lib/style.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { AuthContext } from "../../../context/AuthContext";
import Swal from "sweetalert2";

export function useSignUpOTPScreen() {
    const { SingUpSendCode, SingUpVerify, signIn, setAlert, VerifyPasswordRecovery } = useContext(AuthContext);
    const [_expirationTime, setexpirationTime] = useState();
    const [_waitingTime, setwaitingTime] = useState();
    const parameters = useLocation();
    const route = useNavigate();

    const formik = useFormik({
        initialValues: {
            code1: "",
            code2: "",
            code3: "",
            code4: "",
        },
        onSubmit: async (values) => {
            const screen = parameters.state.screen;
            let res = null;
            if (screen == "NewRecoverPassword") {
                res = await VerifyPasswordRecovery({
                    deliveryChannel: "SMS",
                    otp: values.code1 + values.code2 + values.code3 + values.code4,
                    newPassword: parameters.state.newPassword,
                });

                if (res.status == "PROCESS_OK") {
                    Swal.fire({
                        showCloseButton: true,
                        title: 'Proceso Exitoso',
                        text: "Contraseña actualizada correctamente",
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonColor: '#fd6e0d',
                        // iconColor: "#fd6e0d",
                        confirmButtonText: 'Entendido'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            route("/SignInScreen", {
                                state: { phoneNumber: parameters.state.phoneNumber },
                            });
                        }
                    });
                }
            }
            if (screen == "login") {
                res = await SingUpVerify({
                    deliveryChannel: "SMS",
                    otp: values.code1 + values.code2 + values.code3 + values.code4,
                });

                if (res.status == "PROCESS_OK") {
                    route("/SignInScreen", {
                        state: { phoneNumber: parameters.state.phoneNumber },
                    });
                }
            }
            if (screen == "RecoverPassword") {
                res = await SingUpVerify({
                    deliveryChannel: "SMS",
                    otp: values.code1 + values.code2 + values.code3 + values.code4,
                });


                if (res.status == "PROCESS_OK") {
                    route("/RecoverPassword", {
                        state: { phoneNumber: parameters.state.phoneNumber },
                    });
                }
            }
            if (screen == "SignUpScreen") {
                res = await SingUpVerify({
                    deliveryChannel: "SMS",
                    otp: values.code1 + values.code2 + values.code3 + values.code4,
                });

                if (res.status == "PROCESS_OK") {
                    const _data = {
                        username: parameters.state.phoneNumber,
                        password: parameters.state.newPassword,
                    };
                    let resp = await signIn(_data);
                    if (resp == true) {
                        route("/");
                    }
                }
            }
            if (res.status == "NOT_FOUND") {
                Swal.fire({
                    showCloseButton: true,
                    title: 'Advertencia',
                    text: "Código inválido",
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonColor: '#fd6e0d',
                    iconColor: "#fd6e0d",
                    confirmButtonText: 'Entendido'
                })
            }
        },
        validate: (values) => {
            const errors = {};
            console.log(values);
            if (!values.code1) errors.code1 = "";
            if (!values.code2) errors.code2 = "";
            if (!values.code3) errors.code3 = "";
            if (!values.code4) errors.code4 = "";
            return errors;
        },
    });

    useEffect(() => {
        _SingUpSendCode();
    }, []);

    let expirationTime = 0;
    let waitingTime = 0;
    let idTimerExpirationTime = useRef(0);
    let idTimerWaitingTime = useRef(0);
    async function _SingUpSendCode() {
        const res = await SingUpSendCode();
        console.log("res",res);

        if (res.status == "Bad Request."){
            Swal.fire({
                showCloseButton: true,
                title: 'Advertencia',
                text: "Su solicitud no puede ser procesada",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                iconColor: "#fd6e0d",
                confirmButtonText: 'Entendido'
              }).then((result) => {
                if (result.isConfirmed) {
                    route("/");
                } else {
                    route("/");
                }
            });
        }

        if (res.status == "PROCESS_OK") {
            clearInterval(idTimerExpirationTime.current);
            clearInterval(idTimerWaitingTime.current);
            expirationTime = res.data.expirationTime;
            waitingTime = res.data.waitingTime;
            idTimerExpirationTime.current = setInterval(() => {
                timerExpirationTime();
            }, 1000);
            idTimerWaitingTime.current = setInterval(() => {
                timerWaitingTime();
            }, 1000);
        }

        if (res.status == "OTP Requests exceeded") {
            Swal.fire({
                showCloseButton: true,
                title: 'Reenvios OTP excedidos',
                text: "intente en 5 minutos.",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                iconColor: "#fd6e0d",
                confirmButtonText: 'Entendido'
              }).then((result) => {
                if (result.isConfirmed) {
                    route("/");
                } else {
                    route("/");
                }
              });
       }
    }

    function timerExpirationTime() {
        if (expirationTime == 0) clearInterval(idTimerExpirationTime.current);

        const minutes = Math.floor(expirationTime / 60);
        let seconds = expirationTime % 60;
        setexpirationTime(
            `${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""
            }${seconds}`
        );
        expirationTime = expirationTime - 1;
    }

    function timerWaitingTime() {
        console.log(1);
        if (waitingTime == 0) clearInterval(idTimerWaitingTime.current);

        const minutes = Math.floor(waitingTime / 60);
        let seconds = waitingTime % 60;
        setwaitingTime(
            `${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""
            }${seconds}`
        );

        waitingTime = waitingTime - 1;
    }

    const handleEnter = (event) => {
        const form = event.target.form;
        const index = [...form].indexOf(event.target);
        const val = form.elements[index].value;
        
        formik.setFieldValue(form.elements[index].name, val);

        if (
            event.key.toLowerCase() === "backspace" ||
            event.key.toLowerCase() === "arrowleft"
        ) {
            if (

                form.elements[index - 1] != undefined &&
                form.elements[index - 1].type == "tel"
            ) {
                form.elements[index - 1].focus();
                event.preventDefault();
            }
        } else {
            if (
                form.elements[index + 1] != undefined &&
                form.elements[index + 1].type == "tel"
            ) {
                console.log(form.elements[index + 1].values)
                form.elements[index + 1].focus();
                event.preventDefault();
            }
        }
    };

    return {
        parameters,
        formik,
        handleEnter,
        _expirationTime,
        _waitingTime,
        _SingUpSendCode,
        route
    }
}